import { addDoc, collection } from "@firebase/firestore"
import { showErrorSnackbar, showSuccessSnackbar } from "../../../shared/snackbar/snackbar-slice";
import { addStatus } from "../item-status-list/item-status-list-slice";
import { hideLoading, showLoading } from "./item-status-add-slice";

export const addItemStatusService = async (dispatch, db, coll, formData) => {
    dispatch(showLoading());
    try {
        const docRef = await addDoc(collection(db, coll), formData);
        dispatch(addStatus({
            id: docRef.id,
            ...formData
        }));
        dispatch(showSuccessSnackbar('Added successfully!'));
    } catch(e) {
        dispatch(showErrorSnackbar('Add failed! Please try again.'))
        console.error("ItemStatusAdd addItemStatusService error: ", e);
    }
    dispatch(hideLoading());
};